import { DocumentIsogd, DocumentLinkDocument } from "isogd-document-rest";

class DocumentLinkEditController {
    private document: DocumentIsogd;
    private documentTypes: any[];

    addLinkDocument() {
        if (!this.document.linkDocument) {
            this.document.linkDocument = [];
        }
        let linkDocumentNumber = new DocumentLinkDocument();
        linkDocumentNumber.linkDocumentNumber = '';
        this.document.linkDocument.push(linkDocumentNumber)
    }

    linkDocChange(i, item) {

        this.documentTypes.forEach(t => {
            if (t.docCode === item) {
                this.document.linkDocument[i].linkDocumentTypeName = t.docName;
            }
        });
    }

    deleteLinkDocument(index) {
        this.document.linkDocument.splice(index, 1);
    }
}

export const DocumentLinkEditComponent: angular.IComponentOptions = {
    controller: DocumentLinkEditController,
    template: require('./documentLinkEdit.html'),
    bindings: {
        document: "<",
        documentTypes: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-link/documentLinkEdit.ts